import { Box, Checkbox } from '@factorialco/deprecated-design-system'

import DayPicker from 'modules/core/components/DayPicker'

import type BulkEditForm from 'modules/employees/pages/EditInBulk/forms/BulkEdit'

interface Props {
  bulkEditForm: BulkEditForm
  isChecked: boolean
  onChange: (value: string) => void
  onClick: () => void
  width?: string
  customFieldId: number
}

const CustomFieldDate = ({
  bulkEditForm,
  onChange,
  onClick,
  isChecked,
  width,
  customFieldId,
}: Props) => {
  const onHandleChange = (value: string) => {
    bulkEditForm.setValues({
      [customFieldId]: value,
    })
    onChange(value)
  }

  const value = bulkEditForm.get(customFieldId.toString())?.value

  return (
    <Box
      background="grey000White"
      flexDirection="row"
      justifyContent="spaceBetween"
      alignItems="center"
      height="full"
      paddingX="s16"
      paddingY="s12"
      border={{
        all: {
          width: 's2',
          style: 'solid',
          color: 'grey000White',
        },
      }}
      gap="s16"
      style={{ width }}
    >
      <Box flexNoShrink>
        <Checkbox checked={isChecked} onChange={onClick} />
      </Box>
      <DayPicker valueFormat="backend" format="ui" onChange={onHandleChange} value={value} />
    </Box>
  )
}

export default CustomFieldDate
